import { render, staticRenderFns } from "./Simulation.vue?vue&type=template&id=1fed087a&scoped=true"
import script from "./Simulation.vue?vue&type=script&lang=js"
export * from "./Simulation.vue?vue&type=script&lang=js"
import style0 from "./Simulation.vue?vue&type=style&index=0&id=1fed087a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fed087a",
  null
  
)

export default component.exports